<template>
  <div class="bg-white">
    <!--statistic-->
    <div class="statistic">
      <div class="row">
        <div class="col s12">
          <div class="col-head">
            <router-link :to="$i18nRoute({ name: 'search-npa' })">
              <p><strong>{{ statistics.all_npas }}</strong>{{ $t("проектов всего") }}</p>
            </router-link>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <router-link :to="$i18nRoute({ name: 'search-npa', query: { status: 3 } })">
              <p><strong>{{ statistics.in_discuss }}</strong>{{ $t("проектов на обсуждении") }}</p>
            </router-link>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <router-link :to="$i18nRoute({ name: 'search-npa', query: { status: 5 } })">
              <p><strong>{{ statistics.discuss_close }}</strong>{{ $t("проектов завершено") }}</p>
            </router-link>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <router-link :to="$i18nRoute({ name: 'search-npa', query: { status: 6 } })">
              <p><strong>{{ statistics.adopted }}</strong>{{ $t("принятые проекты") }}</p>
            </router-link>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <p><strong>{{ statistics.comments_public }}</strong>{{ $t("комментариев") }}</p>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <router-link :to="$i18nRoute({ name: 'comment-statistics', params: { id: 1 } })">
              <p><strong>{{ statistics.comments_with_ans }}</strong>{{ $t("комментариев учтено") }}</p>
            </router-link>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <p><strong>{{ statistics.users }}</strong>{{ $t("пользователей") }}<br/>
              {{ $t("в регистрации") }}</p>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <router-link :to="$i18nRoute({ name: 'comment-statistics', params: { id: 2 } })">
              <p><strong>{{ statistics.comments_without_ans }}</strong>{{ $t("не отвеченных комментариев") }}</p>
            </router-link>
          </div>
        </div>
        <div class="col s12">
          <div class="col-head">
            <router-link :to="$i18nRoute({ name: 'comment-statistics', params: { id: 3 } })">
              <p><strong>{{ statistics.answers }}</strong>{{ $t("количество ответов") }}</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!--diagram-->
    <div class="diagram">
      <div class="row">
        <div class="col l4 m12">
          <h4>{{ $t("По разработчикам НПА") }}</h4>
          <div class="diagram-developer">
            <apexcharts height="300" type="bar" :options="devOptions" :series="devData"></apexcharts>
          </div>
        </div>
        <div class="col l4 m12">
          <h4>{{ $t("По видам НПА") }}</h4>
          <div class="diagram-kind">
            <apexcharts type="donut" :options="kindNpaOptions" :series="kindNpaData"></apexcharts>
          </div>
        </div>
<!--        <div class="col l4 m12">-->
<!--          <h4>{{ $t("По активности портала") }}</h4>-->
<!--          <div class="diagram-activity">-->
<!--            <apexcharts type="line" :options="activityOptions" :series="activityData"></apexcharts>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import NPA from '@/model/npa'

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  data() {
    return {
      statistics: [],
      //По разработчикам НПА
      devData: [{
        data: []
      }],
      devOptions: {
        plotOptions: {
          chart: {
            type: 'bar'
          },
          bar: {
            barHeight: '100%',
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
          }
        },
        fill: {
          //type: 'gradient',
          colors: ['#288AC9', '#50D1D7', '#FF265A', '#FDD114', '#1F366B', '#228099', '#93C8EB', '#87D8ED', '#FC859E', '#02336D', '#006EB6', '#009CDE', '#92EBFE', '#DEA16A', '#004EAE', '#00819B', '#FF6D6D', '#258BFF', '#00B5AD', '#FF2168']
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#fff']
          },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },
        labels: [],
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          theme: 'light',
          x: {
            show: true
          },
          y: {
            title: {
              formatter: function () {
                return ''
              }
            }
          },
        }
      },
      //По видам НПА
      kindNpaData: [],
      kindNpaOptions: {
        chart: {
          type: 'donut'
        },
        plotOptions: {
          pie: {
            startAngle: 0,
            donut: {
              size: '45%',
            }
          }
        },
        fill: {
          //type: 'gradient',
          colors: ['#02336D', '#006EB6', '#009CDE', '#92EBFE', '#DEA16A', '#004EAE', '#00819B', '#FF6D6D', '#258BFF', '#00B5AD', '#FF2168', '#288AC9', '#50D1D7', '#FF265A', '#FDD114', '#1F366B', '#228099', '#93C8EB', '#87D8ED', '#FC859E']
        },
        legend: {
          show: false,
        },
        labels: [],
        dataLabels: {
          style: {
            colors: ['#fff']
          },
          offsetX: 245,
          offsetY: 180,
          dropShadow: {
            enabled: true
          }
        }
      },
      //По активности портала
      activityData: [
        {
          name: 'Январь',
          data: [500, 1000, 2500]
        }
      ],
      activityOptions: {
        chart: {
          type: 'line',
          horizontal: true,
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: true
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: ['I', 'II', 'III']
        },
        labels: [
          'Январь',
          'Февраль',
          'Март'
        ],
      }
    }
  },
  mounted() {
    NPA.getPortalStatistics()
      .then((response) => {
        this.statistics = response.data
        this.updateChartNpaDeveloper()
        this.updateChartNpaKind()
      })
      .catch((error) => {
        //@todo ошибки
      })
  },
  methods: {
    //По разработчикам НПА
    updateChartNpaDeveloper() {
      const resName = []
      const resCount = []
      Object.entries(this.statistics.devNpas).forEach((element, key) => {
        resName.push(element[1].transName)
        resCount.push(element[1].cnt)
      })

      this.devData = [{
        data: resCount
      }]
      this.devOptions = {
        labels: resName
      }
    },
    //По видам НПА
    updateChartNpaKind() {
      const resName = this.statistics.viewNpas.map(item => item.transName)
      const resCount = this.statistics.viewNpas.map(item => item.cnt)
      this.kindNpaData = resCount
      this.kindNpaOptions = {
        labels: resName
      }
    }
  }
}
</script>
